import React from "react";
import Box from "@mui/material/Box";
import Container from "../../common/Container";
import Header from "../../components/Header";
import AppBar from "@mui/material/AppBar";
import Footer from "../../components/Footer";
import Banner from "./components/Banner";
import WhoWeAre from "./components/WhoWeAre";
import Image from "../../images/about.jpg";
import Agile from "./components/Agile";
import Scroll from "../Header/Scroll";
import Whatsapp from "../Footer/Whatsapp";

const styles = {
  paperContainer: {
    height: 400,
    backgroundImage: `url(${Image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const About = () => {
  return (
    <Box>
      <Scroll>
        <AppBar
          position={"fixed"}
          elevation={0}
          sx={{
            padding: "10px 0px",
          }}
        >
          <Container paddingY={{ xs: 1 / 2, sm: 1 / 2 }}>
            <Header />
          </Container>
        </AppBar>
      </Scroll>
      <Box bgcolor={"#000"}>
        <Container>
          <Banner />
        </Container>
      </Box>
      <Box style={styles.paperContainer}></Box>
      <Box>
        <Container>
          <WhoWeAre />
        </Container>
      </Box>
      <Box>
        <Container>
          <Agile />
        </Container>
      </Box>
      <Box bgcolor={"#000"}>
        <Container>
          <Footer />
        </Container>
      </Box>
      <Whatsapp />
    </Box>
  );
};

export default About;
